module.exports = __webpack_public_path__ + "static/img07__sp-a018c30593c6afde60bda660373fc63e.svg";